import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { NoTranslate, Tooltip } from '@contently/toolkit';
import LocalizedRelativeDatetime from './relative_datetime';

// # monthYear & monthDay will translate month names but are not fully localized formats.
const formatMap = {
  dateshorthand: 'l',
  date: 'll',
  time: 'LT',
  datetime: 'lll',
  monthYear: 'MMMM YYYY',
  monthDay: 'MMM D'
};

function LocalizedDatetime({ timestamp, formatType }) {
  const momentInstance = moment(timestamp)
    .parseZone();
  const date = momentInstance.format(formatMap[formatType]);

  const time = momentInstance.format(formatMap.time);

  return (
    <NoTranslate>
      <Tooltip content={time}>{date}</Tooltip>
    </NoTranslate>
  );
}

const basePropTypes = PropTypes.shape({
  timestamp: PropTypes.string.isRequired,
  formatType: PropTypes.string.isRequired
});

LocalizedDatetime.propTypes = {
  ...basePropTypes
};

function Datetime({ timestamp, formatType, relative }) {
  if (relative) {
    return <LocalizedRelativeDatetime timestamp={timestamp} />;
  }

  return <LocalizedDatetime timestamp={timestamp} formatType={formatType} />;
}

Datetime.defaultProps = {
  relative: false
};

Datetime.propTypes = {
  ...basePropTypes,
  relative: PropTypes.bool
};

export { Datetime };
export default Datetime;



// WEBPACK FOOTER //
// ./app/javascript/app/components/toolkit/Datetime.jsx